export default {
    /* Dates */
    EVENTS_SET_DATES: 'EVENTS_SET_DATES',
    EVENTS_RESET_DATES: 'EVENTS_RESET_DATES',
    EVENTS_CLEAR_DATES: 'EVENTS_CLEAR_DATES',
    /* Events data */
    GET_EVENTS_DATA: 'GET_EVENTS_DATA',
    GET_EVENTS_DATA_SUCCESS: 'GET_EVENTS_DATA_SUCCESS',
    GET_EVENTS_DATA_ERROR: 'GET_EVENTS_DATA_ERROR',
    /* Events snoozing */
    SNOOZE_EVENT: 'SNOOZE_EVENT',
    UNSNOOZE_EVENT: 'UNSNOOZE_EVENT',
  };
  


// WEBPACK FOOTER //
// ./src/constants/events/eventTypes.js